/**
 * Returns whether an object is undefined or null
 * @param   x
 * @return {Boolean}
 * @example
 * import { isNullOrUndefined } from '@adsk/alloy-react-helpers';
 *
 * const finalObject = (isNullOrUndefined(object) ? {} : { object })
 * @see Table
 */
export default function isNullOrUndefined(x?: unknown) {
  return typeof x === 'undefined' || x === null;
}
